//third party

import { NgModule } from "@angular/core";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { NgxGaugeModule } from "ngx-gauge";
import { MaterialModule } from "../../material.module";
import { FuelGaugeNewComponent } from "./fuel-gauge-new/fuel-gauge-new.component";
import { LineChartComponent } from "./line-chart/linechart.component";
import { StackedBarChartComponent } from "./stacked-bar-chart/stacked-bar-chart.component";
import { PieChartComponent } from "./pie-chart/pie-chart.component";


@NgModule({
  exports: [
    FuelGaugeNewComponent,
    LineChartComponent,
    StackedBarChartComponent,
    PieChartComponent,
    NgxChartsModule,
    NgxGaugeModule
  ],
  declarations: [
    FuelGaugeNewComponent,
    LineChartComponent,
    StackedBarChartComponent,
    PieChartComponent
  ],
  imports: [
    MaterialModule,

    NgxChartsModule,
    NgxGaugeModule
  ]
})
export class ChartsModule { }
